const selectors = {
	cart: {
		edit: '.print-mailing-preference__cart--edit',
		info: '.print-mailing-preference__cart--info',
	},
	preferenceText: {
		subscribed: '.print-mailing-preference__text--subscribed',
		unsubscribed: '.print-mailing-preference__text--unsubscribed',
	},
	button: {
		edit: '.print-mailing-preference__button--edit',
		cancel: '.print-mailing-preference__button--cancel',
	},
	form: {
		userLevel: '#printMailingPreferenceForm',
		companyLevel: '#printMailingAccountPreferenceForm',
	},
	input: {
		userLevel: '#printMailingPreferenceInput',
		companyLevel: '#printMailingAccountPreferenceInput',
	},
	modal: '#accountFormValidationModal',
	modalButton: '#openModalButton',
};

const toggleVisibility = element => {
	element?.classList?.toggle('hidden');
};

const changeCartVisibility = (context, cartType) => {
	toggleVisibility(context.querySelector(selectors.cart[cartType]));
};

const getCurrentPreference = (context, type) => {
	return context.querySelector(selectors.input[type])?.checked;
};

const hasValueChanged = (context, type) => {
	const initialValue =
		context.querySelector('.print-mailing-preference__checkbox-container')
			?.dataset.initialSubscriptionValue === 'true';
	return initialValue !== getCurrentPreference(context, type);
};

const submitFormIfNeeded = (context, type) => {
	if (hasValueChanged(context, type)) {
		context.querySelector(selectors.form[type]).submit();
	} else {
		changeCartVisibility(context, 'info');
		changeCartVisibility(context, 'edit');
	}
};

const handleFormSubmit = (event, context, type) => {
	event.preventDefault();
	submitFormIfNeeded(context, type);
};

const toggleInputState = (context, type) => {
	context.querySelector(selectors.input[type])?.toggleAttribute('checked');
};

const attachEventListeners = (context, type) => {
	context
		.querySelector(selectors.button.edit)
		?.addEventListener('click', () => {
			changeCartVisibility(context, 'info');
			changeCartVisibility(context, 'edit');
		});
	context
		.querySelector(selectors.button.cancel)
		?.addEventListener('click', () => {
			changeCartVisibility(context, 'info');
			changeCartVisibility(context, 'edit');
		});
	context
		.querySelector(selectors.input[type])
		?.addEventListener('change', () => toggleInputState(context, type));
	context
		.querySelector(selectors.form[type])
		?.addEventListener('submit', event =>
			handleFormSubmit(event, context, type),
		);
	context
		.querySelector(selectors.modalButton)
		?.addEventListener('click', () => {
			if (!hasValueChanged(context, type)) {
				changeCartVisibility(context, 'info');
				changeCartVisibility(context, 'edit');
				return;
			}
			const currentCheckboxValue = getCurrentPreference(context, type);
			if (currentCheckboxValue) {
				context.querySelector(selectors.form[type]).submit();
			} else $(selectors.modal).modal('show');
		});
};

const initializePrintMailing = type => {
	const context = document.querySelector(`.${type}`);
	if (!context) return;

	attachEventListeners(context, type);
};

const printMailingPreference = () => {
	['userLevel', 'companyLevel'].forEach(initializePrintMailing);
};

export {
	selectors,
	toggleVisibility,
	changeCartVisibility,
	getCurrentPreference,
	hasValueChanged,
	submitFormIfNeeded,
	handleFormSubmit,
	toggleInputState,
	attachEventListeners,
	initializePrintMailing,
	printMailingPreference as default,
};
